import { GridFooterContainer } from '@mui/x-data-grid';
import CustomPagination from './CustomPagination';
import { type PageType } from 'store/component/pagination';

interface CustomTableFooterProps {
  currentPage: PageType;
  dataCount?: number;
}
const CustomTableFooter = ({
  currentPage,
  dataCount,
}: CustomTableFooterProps): JSX.Element => {
  return (
    <GridFooterContainer>
      <CustomPagination
        rowsPerPageOptions={[5, 10, 20]}
        currentPage={currentPage}
        totalCount={dataCount}
      />
    </GridFooterContainer>
  );
};

export default CustomTableFooter;
